import React, { Component } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Text } from '../../components';
import { typeActions } from '../../webapi';
import { checkLogInScreen, AuthStrategy } from '../../session';

class Login extends Component {
  initialState = {
    loadingBackground: true,
  };

  state = { ...this.initialState };

  UNSAFE_componentWillMount() {
    checkLogInScreen(this, this.props.auth);
    this.getBackground();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.auth) {
      checkLogInScreen(this, nextProps.auth);
    }
  }

  getBackground() {
    typeActions
      .getSubdomain(window.location.host.split('.')[0])
      .then((res) => {
        this.setState({
          loadingBackground: false,
          backgroundImage: res.data.Background,
        });
      })
      .catch((res) => {
        this.setState({
          loadingBackground: false,
        });
      });
  }

  renderUrlSignIn() {
    return (
      <div className="pageContainer flex flex-center flex-center-row">
        <Text type="h3">Signing In</Text>
      </div>
    );
  }

  render() {
    if (this.state.urlSignIn) {
      return this.renderUrlSignIn();
    }
    return (
      <div className={'relative pageContainer'}>
        <div
          className={`backgroundImage ${
            !this.state.loadingBackground && _.isEmpty(this.state.backgroundImage) ? 'backgroundImage-login' : ''
          }`}
          style={!_.isEmpty(this.state.backgroundImage) ? { backgroundImage: `url(${this.state.backgroundImage})` } : null}
        />
        <div className={'poweredByPluss'} />
        <div className={'loginStripe'}>
          <div className={'textAlign-right fontSize-16 text-loginGrey'}>
            <span className={'fontHeavy'}>community</span>
            <span className={'fontRegular '}>manager</span>
          </div>
          <AuthStrategy.LoginComponent />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth } = state;
  return { auth };
};

export default connect(mapStateToProps, {})(withRouter(Login));
